export class Setting {
    id!: number;
    name!: string;
    value!: string;

    created?: Date;

    public load(data: any): Setting {
        Object.assign(this, data);

        if (data.created) {
            this.created = new Date(data.created);
        }

        return this;
    }
}